// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c76dedeb","453":"cb780797","644":"058e4f42","667":"fed11f19"}[chunkId] + ".chunk.js";
};